import React, { useEffect, useState } from 'react';
import '../../../../App.css';
import { useParams } from 'react-router-dom';

const SuccessPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { email } = useParams();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className={`success-container ${isVisible ? 'visible' : ''}`}>
      <div className="success-box">
        <div className="success-icon">
          <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none" stroke="white" strokeWidth="2" />
            <path className="checkmark-check" fill="none" stroke="white" strokeWidth="5" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
          </svg>
        </div>

        <h1 className="success-title">Registration Successful!</h1>

        <div className="message-container">
          <p className="success-message">
            Thank you for joining GradeMe-AI! We've sent a verification link to your email:
          </p>
          <p>{email}</p>
          <div className="email-animation">
            <i className="far fa-envelope"></i>
            <div className="email-line"></div>
          </div>
          <p className="instruction-message">
            Please check your inbox and click the link to verify your account.
          </p>
          <p className="support-message">
            Can't find the email? Check your spam folder or contact our support team:
            <a href="mailto:support@grademe-ai.com" className="support-link">
              support@grademe-ai.com
            </a>
          </p>
        </div>

      </div>
    </div>
  );
};

export default SuccessPage;